import { render, staticRenderFns } from "./addaddress.vue?vue&type=template&id=dd31c12a"
import script from "./addaddress.vue?vue&type=script&lang=js"
export * from "./addaddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports